var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "voiceMessage",
      staticClass: "sc-message--text",
      attrs: { id: "voiceMessagePlayer" },
    },
    [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.toggleAudio()
            },
          },
        },
        [
          _c("md-icon", { attrs: { id: "playButton" } }, [
            _vm._v(_vm._s(_vm.paused ? "play_circle" : "pause_circle")),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("av-waveform", {
        attrs: {
          id: "waveform",
          playtime: false,
          playtimeWithMs: false,
          playtimeTextBottom: false,
          playtimeSliderWidth: 3,
          noplayedLineColor: "#999999",
          "played-line-color": "#6098ff",
          "audio-src": _vm.getSrc(),
          playtimeFontSize: 0,
          canvWidth: 200,
          canvHeight: 40,
          "played-line-width": 0.3,
          "noplayed-line-width": 0.3,
          "playtime-slider-color": "#4E8CFF",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }